import React from 'react'

import {
  
  RealMadrid,
  FCBarcelona,
  AtleticoMadrid,
  ValenciaCF,
  RealSociedad,
  DeportivoLaCoruna,
  AthleticBilbao,
  RealBetis,
  SevillaFC,
  

} from "../clubs";


const LaLiga = () => {
  return (
    <div>
      <h1>Dates of the last league titles for each club that has won La Liga.</h1>
      <FCBarcelona />
      <RealMadrid />
      <AtleticoMadrid />
      <ValenciaCF />
      <DeportivoLaCoruna />
      <AthleticBilbao />
      <RealSociedad />
      <SevillaFC />
      <RealBetis />

      
    </div>
  )
}

export default LaLiga